import {
  CommunicationAndLanguageIcon,
  EmotionalLiteracyIcon,
  MathematicsIcon,
  PhonicsAndLiteracyIcon,
  PhysicalDevelopmentIcon,
  PlaySkillsIcon,
  SocialSkillsIcon,
  UnderstandingTheWorldIcon,
  communityHelpersIcon,
} from '../skillAreas' // Adjust the import path as necessary

const svgMapping = {
  'communication-and-language': CommunicationAndLanguageIcon,
  'emotional-literacy': EmotionalLiteracyIcon,
  'cognition-and-math-skills': MathematicsIcon,
  'phonics-and-literacy': PhonicsAndLiteracyIcon,
  'physical-development': PhysicalDevelopmentIcon,
  'play-skills': PlaySkillsIcon,
  'social-skills': SocialSkillsIcon,
  'understanding-the-world': UnderstandingTheWorldIcon,
  'emotional-abilities': EmotionalLiteracyIcon,
   'mathematic': MathematicsIcon,
  'cognitive-skills': UnderstandingTheWorldIcon,
  'receptive-language': PlaySkillsIcon,
  'expressive-language': PlaySkillsIcon,
  'social-awareness-and-community-helpers': communityHelpersIcon,
  'community-helpers': communityHelpersIcon,
}

export const getSvgComponent = (textValue: string) => {
  const normalizedText = textValue.toLowerCase().replace(/\s+/g, '-')
  return svgMapping[normalizedText] || PlaySkillsIcon
}
